import OikosButton from "../OikosDesignSystem/OikosButton";
import React from "react";
import {useAuth} from "../Hooks/useAuth";
import {Stack, useToast} from "@chakra-ui/react";
import {useOikos} from "../SDK/OikosContext";


const SessionsButtonsLearner:React.FC<{
  session: OIKOS.Session
  closeDrawer: () => void
}> = ({session, closeDrawer}) => {

  const {oikosUser} = useAuth();
  const toast = useToast()
  const {oikos} = useOikos();

  const roomName = session.Educator + session.Learner;

  return (
    <>
      {/*Session Requested*/}
      {( session.Status === 1) && (
        <Stack width={"100%"}>
          <OikosButton
            buttonText={"Cancel Session"}
            width={"100%"}
            onClick={() => {
              oikos.sessionCancelByLearner(session.ID)
                .then(() => {
                  toast({
                    title: "Session cancelled",
                    description: "Session cancelled successfully.",
                    status: "success",
                    duration: 9000,
                    isClosable: true,
                    position: "top-right",
                  })
                  closeDrawer();
                })
                .catch((err) => {
                  toast({
                    title: "Error cancelling the session",
                    description: "There was an error cancelling the session. Please try again later.",
                    status: "error",
                    duration: 9000,
                    isClosable: true,
                    position: "top-right",
                  })
                })
            }}
          />
        </Stack>
      )}


      {( session.Status === 2) && (
        <Stack width={"100%"}>
          <OikosButton
            buttonText={"Start Session"}
            width={"100%"}
            onClick={() => {
              window.open(`https://stoa.polis.ac/room/${roomName}/${oikosUser.ID}`, '_blank')
            }}
          />
          <OikosButton
            buttonText={"Cancel Session"}
            width={"100%"}
            variant={"outline"}
            onClick={() => {
              oikos.sessionCancelByLearner(session.ID)
                .then(() => {
                  toast({
                    title: "Session cancelled",
                    description: "Session cancelled successfully.",
                    status: "success",
                    duration: 9000,
                    isClosable: true,
                    position: "top-right",
                  })
                  closeDrawer();
                })
                .catch((err) => {
                  toast({
                    title: "Error cancelling the session",
                    description: "There was an error cancelling the session. Please try again later.",
                    status: "error",
                    duration: 9000,
                    isClosable: true,
                    position: "top-right",
                  })
                })
            }}
          />
        </Stack>
      )}
    </>
  )


}

export default SessionsButtonsLearner;
